import baseService from '../shared/baseService';

const sourceService = (clientId: number) =>
  baseService(`clients/${clientId}/sources`);
const sourceServiceDownload = (clientId: number) =>
  baseService('clients').download(`/${clientId}/sources/download`);

export default {
  sourceService,
  sourceServiceDownload,
};
